<template>
<div class="select-country" @click.stop="() => {}">
  <div class="country-input-box" @mouseenter="inputMouseEnter" @mouseleave="inputMouseLeave">
    <div class="country-input" :class="{active: visibleSelectCountry}" @click="showCountryList">
      <span class="placeholder" v-if="!selectCountryId">{{placeholder}}</span>
      <span class="input-value" v-else>{{allCountryMap[selectCountryId]}}</span>
      <div class="input-right-icon">
        <div class="delete-icon" @click.stop="clearInputValue" v-if="selectCountryId && inputHover"></div>
        <div class="down-icon" v-else></div>
      </div>
    </div>
  </div>
  <div class="select-country-list" v-if="visibleSelectCountry" >
    <div class="country-list-left">
      <div class="country-left-item"
        :class="{'tab-hover':countryTab===con.continent_id}"
        v-for="(con, index) in continentArr"
        :key="index"
        @mouseenter="toggleCountryTab(con.continent_id)"
      >
        <span class="text">{{continentMap[con.continent_id].cn_name}}</span>
        <span v-if="con.continent_id !== 3">&nbsp;&nbsp;</span>
      </div>
    </div>
    <div class="country-list-right">
      <div class="country-right-item" v-for="(con, outIndex) in continentArr" v-show="countryTab === con.continent_id" :key="outIndex">
        <div class="country-item-box" v-for="(c, inIndex) in con.country" :key="inIndex">
          <div class="country-item" :class="{active: c.visa_country_id === selectCountryId}" @click="selectCountry(c.visa_country_id)" >{{c.country}}</div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>
<script>
import Http from '../../libs/http';

export default {
  name: 'select-country',
  props: {
    placeholder: {
      type: String,
      default: '请选择，问题与国家无关可不选',
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      continentMap: {
        0: {
          cn_name: '亚洲',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/continent-0.png',
        },
        1: {
          cn_name: '欧洲',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/continent-1.png',
        },
        2: {
          cn_name: '美洲',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/continent-2.png',
        },
        3: {
          cn_name: '大洋洲',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/continent-3.png',
        },
        4: {
          cn_name: '非洲',
          icon: 'https://o.666visa.cn/static/ssqpeer/homepage/continent-4.png',
        },
      },
      continentArr: [],
      countryTab: 0,
      allCountryMap: {},
      selectCountryId: this.value,
      visibleSelectCountry: false,
      inputHover: false,
    };
  },
  created() {
    Http.post('/sys/visa_continent_query')
      .then((data) => {
        this.continentArr = data.continent;
        const allCountryMap = {};
        data.continent.forEach((continentItem) => {
          continentItem.country.forEach((countryItem) => {
            allCountryMap[countryItem.visa_country_id] = countryItem.country;
          });
        });
        this.allCountryMap = allCountryMap;
      }).catch((e) => {
        if (e) console.log(e);
      });
  },
  mounted() {
    document.body.addEventListener('click', this.hideCountryList);
  },
  destroyed() {
    document.body.removeEventListener('click', this.hideCountryList);
  },
  watch: {
    selectCountryId(value) {
      this.$emit('input', value);
    },
    value(value) {
      this.selectCountryId = value;
    },
  },
  methods: {
    clearInputValue() {
      this.selectCountryId = 0;
    },
    toggleCountryTab(tab) {
      this.countryTab = tab;
    },
    selectCountry(country_id) {
      this.selectCountryId = country_id;
      this.visibleSelectCountry = false;
    },
    showCountryList() {
      if (!this.visibleSelectCountry) {
        this.visibleSelectCountry = true;
      } else {
        this.visibleSelectCountry = false;
      }
    },
    hideCountryList() {
      this.visibleSelectCountry = false;
    },
    inputMouseEnter() {
      this.inputHover = true;
    },
    inputMouseLeave() {
      this.inputHover = false;
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../assets/less/variable.less';
.select-country{
  position: relative;
}
.country-input{
  user-select: none;
  width: 100%;
  border:1px solid rgba(222,226,230,1);
  background:rgba(255,255,255,1);
  border-radius:2px;
  height: 40px;
  position: relative;
  padding: 0 30px 0 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #2F333D;
  cursor: pointer;
  .input-right-icon{
    width: 30px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .down-icon{
      background: url(../../assets/imgs/homepage/select-icon-down.png) no-repeat;
      background-size: 100% 100%;
      width: 8px;
      height: 8px;
      transition: 0.15s all;
    }
    .delete-icon{
      background: url(../../assets/imgs/homepage/select-delete-icon.png) no-repeat;
      background-size: 100% 100%;
      width: 12px;
      height: 12px;
    }
  }
  &.active{
    .input-right-icon{
      .down-icon{
        transform: rotate(180deg);
        transform-origin: center center;
      }
    }
  }
  .placeholder{
    color: #91999F;
  }
}
.select-country-list{
  margin-top: 6px;
  width: 100%;
  position: absolute;
  z-index: 99;
  top: 100%;
  left: 0;
  background: #fff;
  box-shadow:0px 8px 12px 0px rgba(57,61,70,0.06);
  display: flex;
  font-size: 14px;
  cursor: default;
  border-radius: 2px;

  .country-list-left{
    flex-shrink: 1;
    flex-grow: 1;
    width: 90px;
    background: #E9EEF2;
    border-radius: 2px 0 0 2px;
    .country-left-item{
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #2F333D;
      .icon{
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
      &.tab-hover{
        color: #fff;
        background: #599FFF;
      }
    }
  }
  .country-list-right{
    flex-shrink: 1;
    flex-grow: 1;
    width: 375px;
    border: 1px solid #E9EEF2;
    border-radius: 0 2px 2px 0;
    .country-right-item{
      padding: 16px;
      display: flex;
      flex-wrap: wrap;
      margin-right: -3px;
      margin-left: -3px;
      margin-bottom: -16px;
      .country-item-box{
        width: 25%;
        padding: 0 3px;
        margin-bottom: 16px;
        .country-item{
          cursor: pointer;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #2F333D;
          font-weight: 600;
          line-height: 20px;
          &.active{
            color: #599FFF;
          }
          &:hover{
            color: @new-blue;
          }
        }
      }

    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/common/select-country.vue